import ConfirmModal from "../../../components/confirmViewModal/ConfirmModal";
import { TwScope } from "../../../components/ui/TwScope";
import LoadingOverlay from "../shared/components/LoadingOverlay";
import UserDetailsModal from "../userDetails/UserDetailsModal";
import UserEditModal from "../userEdit/UserEditModal";
import UserRegisterModal from "../userRegister/UserRegisterModal";
import UserListHeader from "./components/UserListHeader";
import UserListPagination from "./components/UserListPagination";
import UserTable from "./components/UserTable";
import { useUserListViewModel } from "./hooks/useUserListViewModel";

/**
 * Tailwind rebuild of the User grid, following `CompanyListNew`: a `TwScope`
 * page shell composing header/table/pagination, with all state and
 * data-fetching in `useUserListViewModel`. Gated behind
 * `ENABLE_LCA_USER_UI_REDESIGN` — see src/routes/userRoutes.tsx for the
 * switch against the untouched legacy `UserList`
 * (src/screens/user/userList/UserList.tsx).
 *
 * Every legacy capability is kept: register / view / edit / delete and the
 * page-size selector. (The legacy filter bar was never wired to anything.)
 */
const UserListNew = () => {
  const vm = useUserListViewModel();

  return (
    <TwScope className="tw-min-h-full tw-bg-white tw-p-6">
      <UserListHeader onRegisterClick={vm.openRegisterModal} />

      <UserTable
        rows={vm.rows}
        isLoading={vm.isRowsLoading}
        onView={vm.openDetailsModal}
        onEdit={vm.openEditModal}
        onDelete={vm.openDeleteConfirm}
      />

      <UserListPagination
        totalCount={vm.totalCount}
        pageNumber={vm.pageNumber}
        totalPages={vm.totalPages}
        pageSize={vm.pageSize}
        onPageChange={vm.handlePagination}
        onPageSizeChange={vm.handlePageSize}
      />

      <UserRegisterModal
        visibleModal={vm.visibleRegisterModal}
        closeModal={vm.closeRegisterModal}
        onSuccess={vm.onSuccessRegister}
        roles={vm.roles}
      />

      <UserDetailsModal
        visibleModal={vm.visibleDetailsModal}
        id={vm.detailsId}
        roles={vm.roles}
        setVisibleModal={vm.closeDetailsModal}
        setVisibleEdit={vm.navigateDetailsToEdit}
      />

      <UserEditModal
        visibleModal={vm.visibleEditModal}
        id={vm.editId}
        roles={vm.roles}
        closeModal={vm.closeEditModal}
        onSuccess={vm.onSuccessEdit}
      />

      <ConfirmModal
        viewModal={vm.visibleDeleteConfirm}
        closeModal={vm.closeDeleteConfirm}
        cancel={vm.closeDeleteConfirm}
        approve={vm.confirmDelete}
        title="Delete user data"
        subTitle="Are you sure you want to delete your user?"
      />

      {vm.isDeleting ? <LoadingOverlay /> : null}
    </TwScope>
  );
};

export default UserListNew;
